import * as React from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CloseIcon from '@mui/icons-material/Close';
import { Settings, Logout } from '@mui/icons-material';
import PasswordIcon from '@mui/icons-material/Password';

import { useNavigate } from 'react-router-dom';
import { userSettingPage, passwordChangePage } from '../../../constants/pages';
import useLogin from '../../../hooks/useLogin';
import useI18n from '../../../hooks/useI18n';

// Buttons values:
// const btn = {
//   text: '',
//   onClick: () => { },
//   icon: <MailIcon />
// }


export default function SlideBarButtonList(prop) {
  const { buttons, open, activePage, user, handleDialogClose } = prop;

  const navigate = useNavigate();
  const { logout } = useLogin();
  const { l } = useI18n();

  const logoutUser = () => {
    logout();
    handleDialogClose();
  }

  const hendleSettings = () => {
    handleDialogClose();
    navigate(userSettingPage)
  }

  const handlePasswordChange = () => {
    handleDialogClose();
    navigate(passwordChangePage)
  }

  return (
    < List >
      <ListItem disablePadding sx={{ display: { xs: 'block', md: 'none' }, width: '100%' }}>
        <ListItemButton
          sx={{
            minHeight: 48,
            px: 2.5,
            width: '100%'
          }}
          onClick={handleDialogClose}>
          <ListItemIcon
            sx={{
              minWidth: 0,
              justifyContent: 'center',
            }}
          >
            <CloseIcon />
          </ListItemIcon>
        </ListItemButton>
      </ListItem>
      {
        buttons.map((btn, index) => btn.role === user?.user_role || !btn?.role ? (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              sx={{
                minHeight: 48,
                justifyContent: open ? 'initial' : 'center',
                px: 2.5,
                backgroundColor: btn.text === activePage ? '#F5F5F5' : 'white',
              }}
              onClick={() => {
                btn?.onClick();
                if (handleDialogClose) handleDialogClose()
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: open ? 3 : 'auto',
                  justifyContent: 'center',
                }}
                className={btn.text === activePage ? 'active-button' : ""}
              >
                {btn?.icon}
              </ListItemIcon>
              <ListItemText primary={btn?.text} sx={{ opacity: open ? 1 : 0 }} />
            </ListItemButton>
          </ListItem>
        ) : '')
      }
      <ListItem sx={{ display: { xs: 'block', md: 'none' }, padding: '0' }} onClick={hendleSettings}>
        <ListItemButton sx={{ padding: '12px 0px 12px 22px' }}>
          <ListItemIcon sx={{ minWidth: '46px' }}>
            <Settings fontSize="small" />
          </ListItemIcon>
          {l('Settings')}
        </ListItemButton>
      </ListItem>

      <ListItem sx={{ display: { xs: 'block', md: 'none' }, padding: '0' }} onClick={handlePasswordChange}>
        <ListItemButton sx={{ padding: '12px 0px 12px 22px' }}>
          <ListItemIcon sx={{ minWidth: '46px' }}>
            <PasswordIcon fontSize="small" />
          </ListItemIcon>
          {l('Change password')}
        </ListItemButton>
      </ListItem>

      <ListItem sx={{ display: { xs: 'block', md: 'none' }, padding: '0' }} onClick={logoutUser}>
        <ListItemButton sx={{ padding: '12px 0px 12px 22px' }}>
          <ListItemIcon sx={{ minWidth: '46px' }}>
            <Logout fontSize="small" />
          </ListItemIcon>
          {l('Logout')}
        </ListItemButton>
      </ListItem>
    </List >
  );
}
